import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { ProjectFormValues } from "./types";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Checkbox } from "@/components/ui/checkbox";
import { useAuth } from "@/contexts/AuthContext";

interface TeamMembersFieldProps {
  form: UseFormReturn<ProjectFormValues>;
}

export const TeamMembersField = ({ form }: TeamMembersFieldProps) => {
  const { session } = useAuth();

  const { data: users, isLoading } = useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      if (!session) return [];
      const { data, error } = await supabase
        .from("profiles")
        .select("id, full_name, email");
      if (error) throw error;
      return data;
    },
    enabled: !!session,
  });

  const selectedTeamMembers = form.watch("team_member_ids") || [];

  return (
    <FormField
      control={form.control}
      name="team_member_ids"
      render={() => (
        <FormItem>
          <FormLabel>Miembros del Equipo</FormLabel>
          <div className="space-y-2 max-h-48 overflow-y-auto border rounded-md p-3">
            {isLoading ? (
              <div className="text-sm text-muted-foreground">Cargando usuarios...</div>
            ) : users && users.length > 0 ? (
              users.map((user: any) => (
                <FormField
                  key={user.id}
                  control={form.control}
                  name="team_member_ids"
                  render={({ field }) => {
                    return (
                      <FormItem
                        key={user.id}
                        className="flex flex-row items-start space-x-3 space-y-0"
                      >
                        <FormControl>
                          <Checkbox
                            checked={field.value?.includes(user.id)}
                            onCheckedChange={(checked) => {
                              const current = field.value || [];
                              return checked
                                ? field.onChange([...current, user.id])
                                : field.onChange(
                                    current.filter((id: string) => id !== user.id)
                                  );
                            }}
                          />
                        </FormControl>
                        <div className="space-y-1 leading-none">
                          <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                            {user.full_name || user.email}
                          </label>
                          {user.full_name && user.email && (
                            <p className="text-xs text-muted-foreground">{user.email}</p>
                          )}
                        </div>
                      </FormItem>
                    );
                  }}
                />
              ))
            ) : (
              <div className="text-sm text-muted-foreground">
                No hay usuarios disponibles
              </div>
            )}
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
